import React from 'react'
import { gql, useLazyQuery } from '@moonpig/web-core-graphql'
import {
  UpcomingReminderOccasionQuery,
  UpcomingReminderOccasionQueryVariables,
} from './__generated__/ShopForReminderModule'
import { ShopForReminderContent } from './ShopForReminderContent'
import { PRODUCT_FIELDS_FRAGMENT } from '../../../../queries/productFields'

export const NextReminderGQL = gql`
  query UpcomingReminderOccasion($endDate: String!) {
    nextUnfulfilledReminder(endDate: $endDate) {
      id
      nextDate
      name
      occasion
      recommendations {
        products {
          ...ProductFields
        }
      }
    }
  }

  ${PRODUCT_FIELDS_FRAGMENT}
`

export const ShopForReminderModule = () => {
  const [_, { data, previousData, loading, error }] = useLazyQuery<
    UpcomingReminderOccasionQuery,
    UpcomingReminderOccasionQueryVariables
  >(NextReminderGQL)

  return (
    <ShopForReminderContent
      loading={loading}
      error={!!error}
      reminder={
        data?.nextUnfulfilledReminder || previousData?.nextUnfulfilledReminder
      }
    />
  )
}
